import React from "react";
import "./section.scss";

export default function Section({ children, name = "" }) {
  return <div className={`section section--${name}`}>{children}</div>;
}
